import { route } from 'react-router-typesafe-routes/dom'

export const CORE_ROUTES = {
  noAccess: route('et/no-access'),
  notFound: route('et/not-found'),
  companySelection: route('et/companySelection'),
  error: route('et/error'),
}
